import { useJurisdiction } from './use-jurisdiction';

export enum E_US_ACCOUNT_ACCESS_STATE {
  AUTHENTICATED = 'authenticated',
  CAN_ONBOARD = 'can_onboard',
  SIGNED_OUT = 'signed_out',
}

export interface IUsAccountAccess {
  state: E_US_ACCOUNT_ACCESS_STATE;
  isUsAuthenticated: boolean;
  hasCrossRegionAccountAccess: boolean;
}

export const useUsAccountAccessState = (
  hasUsSession: boolean
): IUsAccountAccess => {
  const { accounts } = useJurisdiction();
  const hasEuOrUk = accounts.hasEuAccount || accounts.hasUkAccount;

  let state: E_US_ACCOUNT_ACCESS_STATE;

  if (hasUsSession) {
    state = E_US_ACCOUNT_ACCESS_STATE.AUTHENTICATED;
  } else {
    const canOnboard = hasEuOrUk && !accounts.hasUsAccount;

    state = canOnboard
      ? E_US_ACCOUNT_ACCESS_STATE.CAN_ONBOARD
      : E_US_ACCOUNT_ACCESS_STATE.SIGNED_OUT;
  }

  return {
    state,
    isUsAuthenticated: state === E_US_ACCOUNT_ACCESS_STATE.AUTHENTICATED,
    hasCrossRegionAccountAccess:
      state === E_US_ACCOUNT_ACCESS_STATE.CAN_ONBOARD ||
      (state === E_US_ACCOUNT_ACCESS_STATE.AUTHENTICATED && hasEuOrUk),
  };
};
